import React from "react";
import { Dialog } from "primereact/dialog";
import "./IconSelect.css";

const IconSelect = ({ visible, onSelect, onClose }) => {
    const icons = [
        "pi pi-folder",
        "pi pi-user",
        "pi pi-chart-line",
        "pi pi-layer",
        "pi pi-cloud",
        "pi pi-cog",
        "pi pi-sitemap",
        "pi pi-briefcase",
        "pi pi-database",
        "pi pi-key",
        "pi pi-lock",
        "pi pi-book",
        "pi pi-calendar",
        "pi pi-image",
        "pi pi-thumbs-up",
        "pi pi-file",
        "pi pi-compass",
        "pi pi-microchip",
        "pi pi-shield",
        "pi pi-wallet",
        "pi pi-search",
        "pi pi-globe",
        "pi pi-mobile",
        "pi pi-rocket",
        "pi pi-server",
        "pi pi-wifi",
        "pi pi-chart-bar",
        "pi pi-chart-pie",
        "pi pi-bolt",
        "pi pi-clock",
        "pi pi-tablet",
        "pi pi-desktop",
        "pi pi-video",
        "pi pi-camera",
        "pi pi-print",
        "pi pi-inbox",
        "pi pi-cube",
        "pi pi-map",
        "pi pi-earth",
        "pi pi-network",
        "pi pi-signal",
        "pi pi-palette",
        "pi pi-tools",
        "pi pi-sun",
        "pi pi-moon",
        "pi pi-flag",
        "pi pi-language",
        "pi pi-globe-americas",
        "pi pi-bell",
        "pi pi-user-plus",
        "pi pi-comment",
        "pi pi-comments",
        "pi pi-users",
        "pi pi-folder-open",
        "pi pi-folder-plus",
        "pi pi-folder-minus",
        "pi pi-envelope",
        "pi pi-paperclip",
        "pi pi-cloud-upload",
        "pi pi-cloud-download",
        "pi pi-bookmark",
        "pi pi-tag",
        "pi pi-tags",
        "pi pi-keyboard",
        "pi pi-mouse",
        "pi pi-battery",
        "pi pi-lightbulb",
        "pi pi-info-circle",
        "pi pi-question-circle",
        "pi pi-heart",
        "pi pi-star",
        "pi pi-check-circle",
        "pi pi-times-circle",
        "pi pi-warning",
        "pi pi-link",
        "pi pi-external-link",
        "pi pi-code",
        "pi pi-eye",
        "pi pi-eye-slash",
        "pi pi-arrow-up",
        "pi pi-arrow-right",
        "pi pi-arrow-down",
        "pi pi-arrow-left",
        "pi pi-angle-up",
        "pi pi-angle-right",
        "pi pi-angle-down",
        "pi pi-angle-left",
        "pi pi-step-backward",
        "pi pi-step-forward",
        "pi pi-play",
        "pi pi-pause",
        "pi pi-stop",
        "pi pi-eject",
        "pi pi-volume-up",
        "pi pi-volume-off",
        "pi pi-spinner",
    ];

    return (
        <Dialog
            header="Select an Icon"
            visible={visible}
            style={{ width: "600px" }}
            onHide={onClose}
        >
            <div className="icon-grid">
                {icons.map((icon, index) => (
                    <i
                        key={index}
                        className={`${icon} icon-option`}
                        onClick={() => onSelect(icon)}
                    />
                ))}
            </div>
        </Dialog>
    );
};

export default IconSelect;
